import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a47afa3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "tableWrapperRef",
  class: "base-table-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "table-toolbar"
}
const _hoisted_3 = {
  key: 0,
  class: "query-form-wrapper"
}
const _hoisted_4 = {
  key: 1,
  class: "pagination-wrapper"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots['query-form'] || _ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.$slots['query-form'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "query-form", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showPagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next, sizes",
                  small: "",
                  "current-page": _ctx.page,
                  "page-size": _ctx.size,
                  total: _ctx.total,
                  "page-sizes": _ctx.pageSizes,
                  "onUpdate:currentPage": _ctx.onPageChange,
                  "onUpdate:pageSize": _ctx.onSizeChange
                }, null, 8, ["current-page", "page-size", "total", "page-sizes", "onUpdate:currentPage", "onUpdate:pageSize"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
      ref: "tableRef",
      data: _ctx.data,
      border: _ctx.border,
      class: "table",
      height: _ctx.autoHeight,
      size: "small",
      "table-layout": "fixed",
      "highlight-current-row": "",
      "row-key": _ctx.rowKey,
      "row-style": _ctx.rowStyle,
      onSelectionChange: _ctx.handleSelectionChange,
      onSortChange: _ctx.handleSort,
      onExpandChange: _ctx.handleExpandChange,
      onRowDblclick: _ctx.handleRowDblClick
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        (_ctx.showIndex)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              align: "center",
              label: "#",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString((_ctx.page - 1) * _ctx.size + scope.$index + 1), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.selectable)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              selectable: _ctx.rowSelectable,
              "reserve-selection": _ctx.reserveSelection,
              type: "selection",
              align: "center",
              width: "40"
            }, null, 8, ["selectable", "reserve-selection"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internalColumns, (col) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: col.prop || col.label
          }, [
            (col.type === 'expand')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  type: "expand",
                  width: col.width
                }, {
                  default: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, "expand", _mergeProps({ ref_for: true }, scope), undefined, true)
                  ]),
                  _: 2
                }, 1032, ["width"]))
              : (col.children)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    align: col.align || 'left',
                    "header-align": col.headerAlign || col.align || 'left'
                  }, {
                    header: _withCtx(() => [
                      (col.headerSlot)
                        ? _renderSlot(_ctx.$slots, col.headerSlot, {
                            key: 0,
                            col: col
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createTextVNode(_toDisplayString(col.label) + " ", 1),
                            (col.value !== undefined)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" : " + _toDisplayString(col.value), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.children, (child) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: child.prop || child.label
                        }, [
                          (child.children)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                align: child.align || 'left',
                                "header-align": child.headerAlign || child.align || 'left',
                                fixed: child.fixed
                              }, {
                                header: _withCtx(() => [
                                  (child.headerSlot)
                                    ? _renderSlot(_ctx.$slots, child.headerSlot, {
                                        key: 0,
                                        col: child
                                      }, undefined, true)
                                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(child.label), 1))
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandchild) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: grandchild.prop,
                                      prop: grandchild.prop,
                                      label: grandchild.label,
                                      width: grandchild.width,
                                      "min-width": grandchild.minWidth || 100,
                                      sortable: grandchild.sortable || false,
                                      "sort-method": grandchild.sortMethod,
                                      filters: grandchild.filters,
                                      "filter-method": grandchild.filterMethod,
                                      align: grandchild.align || 'left',
                                      "header-align": grandchild.headerAlign || grandchild.align || 'left',
                                      fixed: grandchild.fixed
                                    }, _createSlots({ _: 2 }, [
                                      (grandchild.slot)
                                        ? {
                                            name: "default",
                                            fn: _withCtx((scope) => [
                                              _renderSlot(_ctx.$slots, grandchild.slot, _mergeProps({ ref_for: true }, scope, { col: grandchild }), undefined, true)
                                            ]),
                                            key: "0"
                                          }
                                        : {
                                            name: "default",
                                            fn: _withCtx((scope) => [
                                              _createTextVNode(_toDisplayString(scope.row[grandchild.prop]), 1)
                                            ]),
                                            key: "1"
                                          }
                                    ]), 1032, ["prop", "label", "width", "min-width", "sortable", "sort-method", "filters", "filter-method", "align", "header-align", "fixed"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["align", "header-align", "fixed"]))
                            : (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 1,
                                prop: child.prop,
                                label: child.label,
                                width: child.width,
                                "min-width": child.minWidth || 100,
                                sortable: child.sortable || false,
                                "sort-method": child.sortMethod,
                                filters: child.filters,
                                "filter-method": child.filterMethod,
                                align: child.align || 'left',
                                "header-align": child.headerAlign || child.align || 'left',
                                fixed: child.fixed
                              }, _createSlots({ _: 2 }, [
                                (child.slot)
                                  ? {
                                      name: "default",
                                      fn: _withCtx((scope) => [
                                        _renderSlot(_ctx.$slots, child.slot, _mergeProps({ ref_for: true }, scope, { col: child }), undefined, true)
                                      ]),
                                      key: "0"
                                    }
                                  : {
                                      name: "default",
                                      fn: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row[child.prop]), 1)
                                      ]),
                                      key: "1"
                                    }
                              ]), 1032, ["prop", "label", "width", "min-width", "sortable", "sort-method", "filters", "filter-method", "align", "header-align", "fixed"]))
                        ], 64))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["align", "header-align"]))
                : (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    prop: col.prop,
                    label: col.label,
                    width: col.width,
                    "min-width": col.minWidth || 100,
                    sortable: col.sortable || false,
                    "sort-method": col.sortMethod,
                    filters: col.filters,
                    "filter-method": col.filterMethod,
                    align: col.align || 'left',
                    "header-align": col.headerAlign || col.align || 'left',
                    fixed: col.fixed
                  }, _createSlots({ _: 2 }, [
                    (col.slot)
                      ? {
                          name: "default",
                          fn: _withCtx((scope) => [
                            _renderSlot(_ctx.$slots, col.slot, _mergeProps({ ref_for: true }, scope, { col: col }), undefined, true)
                          ]),
                          key: "0"
                        }
                      : {
                          name: "default",
                          fn: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.row[col.prop]), 1)
                          ]),
                          key: "1"
                        }
                  ]), 1032, ["prop", "label", "width", "min-width", "sortable", "sort-method", "filters", "filter-method", "align", "header-align", "fixed"]))
          ], 64))
        }), 128)),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 16, ["data", "border", "height", "row-key", "row-style", "onSelectionChange", "onSortChange", "onExpandChange", "onRowDblclick"])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 512))
}